import React from 'react'
import type { Plan } from '../types'
import { DraggableList, type DraggableItem } from '@/shared/ui/DraggableList'
import { Input, Button, Label } from '@/shared/ui'
import { bulkUpdatePlanMeta } from '../services/planAdminService'
import { PLAN_INTERVAL_LABEL, type PlanInterval } from '../types'

type Props = {
  plans: Plan[]
  onSaved: () => void
}

export default function PlansHomeControl({ plans, onSaved }: Props) {
  const sorted = React.useMemo(() => {
    return [...plans].sort((a, b) => (a.meta?.home_position ?? 999) - (b.meta?.home_position ?? 999))
  }, [plans])

  const [order, setOrder] = React.useState<string[]>(sorted.map(p => p.id))
  const [popularId, setPopularId] = React.useState<string | null>(() => plans.find(p => p.meta?.popular)?.id ?? null)
  const [discounts, setDiscounts] = React.useState<Record<string, number>>(() => {
    const map: Record<string, number> = {}
    for (const p of plans) if (typeof p.meta?.annual_discount_percent === 'number') map[p.id] = p.meta!.annual_discount_percent
    return map
  })
  React.useEffect(() => setOrder(sorted.map(p => p.id)), [sorted.map(p=>p.id).join('|')])

  const items: DraggableItem[] = sorted.map(p => ({
    id: p.id,
    label: `${p.name} • ${PLAN_INTERVAL_LABEL[p.interval as PlanInterval] ?? p.interval}`,
  }))

  function renderRight(it: DraggableItem) {
    const plan = plans.find(p => p.id === it.id)
    if (!plan) return null
    return (
      <div className="flex items-center gap-4">
        <label className="flex items-center gap-2 text-xs">
          <input type="radio" name="popularPlan" checked={popularId === plan.id} onChange={() => setPopularId(plan.id)} /> Popular
        </label>
        <div className="flex items-center gap-2 text-xs">
          <Label className="hidden sm:block">Desconto anual %</Label>
          <Input
            type="number"
            className="h-8 w-20"
            min={0}
            max={99}
            value={discounts[plan.id] ?? ''}
            onChange={(e) => setDiscounts({ ...discounts, [plan.id]: Number(e.target.value || 0) })}
          />
        </div>
        
      </div>
    )
  }

  async function handleSave() {
    const updates: Array<{ id: string; meta: Record<string, any> }> = []
    // Save order
    order.forEach((id, idx) => updates.push({ id, meta: { home_position: idx } }))
    // Popular flag
    for (const p of plans) {
      updates.push({ id: p.id, meta: { popular: p.id === popularId } })
    }
    // Discounts
    for (const [id, pct] of Object.entries(discounts)) {
      updates.push({ id, meta: { annual_discount_percent: Math.max(0, Math.min(99, Math.floor(Number(pct) || 0))) } })
    }
    await bulkUpdatePlanMeta(updates)
    onSaved()
  }

  return (
    <div className="mt-8 rounded-xl border border-border bg-card p-4">
      <div className="mb-3 text-base font-semibold">Ordem, Popular e Desconto anual</div>
      <DraggableList items={items} onReorder={(ids)=> setOrder(ids)} renderRight={renderRight} />
      <div className="mt-4 flex justify-end">
        <Button onClick={handleSave}>Salvar alterações</Button>
      </div>
    </div>
  )
}
